import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { Chip } from '@mui/material';
// import ErrorHandle from '../ErrorHandle'
// import { ProfileApis } from '../../API/Login/ProfileApi'

export default function BusinessDetails({ profileInfo }) {
    return (
        <Fragment>
            {/* Business summary */}
            <div className="mb-4">
                <div className="card shadow-sm rounded-4">
                    <div className="card-body p-0">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                            <h5 className="mb-0">Business summary</h5>
                            <div className="d-flex gap-2">
                                <button className="btn btn-sm btn-outline-secondary" aria-label="edit">
                                    <i className="bi bi-pencil" />
                                </button>
                                <button className="btn btn-sm btn-outline-secondary" aria-label="delete">
                                    <i className="bi bi-trash" />
                                </button>
                            </div>
                        </div>

                        <h6 className="fw-bold my-3 border-bottom pb-2">{profileInfo?.businessName || 'New York Fleet'}</h6>

                        <div className="row gy-2">
                            <div className="col-sm-4 fw-bold">Legal business name</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.legalName || '—'}</div>

                            <div className="col-sm-4 fw-bold">Business number</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.businessNumber || '—'}</div>

                            {profileInfo?.businessNumber1 && <>
                                <div className="col-sm-4 fw-bold">Business number</div>
                                <div className="col-sm-8 text-muted">{profileInfo?.businessNumber1 || '—'}</div>
                            </>}

                            {profileInfo?.businessNumber2 && <>
                                <div className="col-sm-4 fw-bold">Business number</div>
                                <div className="col-sm-8 text-muted">{profileInfo?.businessNumber2 || '—'}</div>
                            </>}

                            {profileInfo?.businessNumber3 && <>
                                <div className="col-sm-4 fw-bold">Business number</div>
                                <div className="col-sm-8 text-muted">{profileInfo?.businessNumber3 || '—'}</div>
                            </>}

                            <div className="col-sm-4 fw-bold">EIN number</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.einNumber || '—'}</div>

                            <div className="col-sm-4 fw-bold">Keywords</div>
                            <div className="col-sm-8 text-muted">
                                <div className="d-flex flex-wrap gap-2">
                                    {profileInfo?.keywords?.map((item, i) => (
                                        <Chip key={i} label={item} color="warning" variant="filled" size='small' style={{ borderRadius: '6px', backgroundColor: '#FFEAB4', color: '#101828' }} />
                                    ))}
                                </div>
                            </div>

                            <div className="col-sm-4 fw-bold">Services offered</div>
                            <div className="col-sm-8 text-muted">
                                <div className="d-flex flex-wrap gap-2">
                                    {profileInfo?.servicesOfferred?.map((item, i) => (
                                        <Chip key={i} label={item} color="warning" variant="filled" size='small' style={{ borderRadius: '6px', backgroundColor: '#EBEBEB', color: '#101828' }} />
                                    ))}
                                </div>
                            </div>

                            <div className="col-sm-4 fw-bold">Website</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.website || '—'}</div>

                            <div className="col-sm-4 fw-bold">Primary email</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.primaryEmail || '—'}</div>

                            <div className="col-sm-4 fw-bold">Secondary email</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.secondaryEmail || '—'}</div>

                            <div className="col-sm-4 fw-bold">Primary phone number</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.primaryMobileNumber || '—'}</div>

                            <div className="col-sm-4 fw-bold">Secondary phone number</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.secondaryMobileNumber || '—'}</div>

                            <div className="col-sm-4 fw-bold">Head office</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.headOffice || '—'}</div>

                            <div className="col-sm-4 fw-bold">Phone number</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.phoneNumber || '—'}</div>

                            <div className="col-sm-4 fw-bold">Fax</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.faxNumber || '—'}</div>

                            <div className="col-sm-4 fw-bold">Business Address</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.primaryPhone || '—'}</div>

                            <div className="col-sm-4 fw-bold">Address type</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.bussAddressForm?.addressType || '—'}</div>

                            <div className="col-sm-4 fw-bold">Same as billing address</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.bussAddressForm?.sameAsBillingAddress || '—'}</div>

                            <div className="col-sm-4 fw-bold">Business address</div>
                            <div className="col-sm-8 text-muted">{`${profileInfo?.bussAddressForm?.addressLine1} ${profileInfo?.bussAddressForm?.addressLine2}` || '—'}</div>

                            <div className="col-sm-4 fw-bold">Landmark</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.bussAddressForm?.landmark || '—'}</div>

                            <div className="col-sm-4 fw-bold">City</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.bussAddressForm?.cityName || '—'}</div>

                            <div className="col-sm-4 fw-bold">State</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.bussAddressForm?.stateName || '—'}</div>

                            <div className="col-sm-4 fw-bold">Country</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.bussAddressForm?.countryName || '—'}</div>

                            <div className="col-sm-4 fw-bold">ZIP</div>
                            <div className="col-sm-8 text-muted">{profileInfo?.bussAddressForm?.zipCode || '—'}</div>
                            <div className="row mb-3">
                                <div className="col-sm-4 fw-bold">Latitude:</div>
                                <div className="col-sm-8 text-muted">{profileInfo?.bussAddressForm?.latitude || '—'}</div>

                                <div className="col-sm-4 fw-bold">Longitude:</div>
                                <div className="col-sm-8 text-muted">{profileInfo?.bussAddressForm?.longitude || '—'}</div>
                                {/* <div className="col-md-4 fw-bold small">Latitude:</div>
                                        <div className="col-md-2 small">{data.latitude}</div> */}

                                {/* <div className="col-md-4 fw-bold small">Longitude:</div>
                                        <div className="col-md-2 small">{data.longitude}</div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Ownership */}
            {/* <div className="col-12 mb-4">
                        <div className="card shadow-sm rounded-4 p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <h5 className="mb-0">Business ownership</h5>
                                <div className="d-flex gap-2">
                                    <button className="btn btn-sm btn-outline-secondary" aria-label="edit">
                                        <i className="bi bi-pencil" />
                                    </button>
                                </div>
                            </div>

                            <dl className="row gy-2 mb-0 mt-2">
                                <dt className="col-sm-4 text-muted">Owner</dt>
                                <dd className="col-sm-8">{profileInfo?.owner || 'Not shared'}</dd>

                                <dt className="col-sm-4 text-muted">Independent owner?</dt>
                                <dd className="col-sm-8">{profileInfo?.independentOwner ? 'Yes' : 'No'}</dd>
                            </dl>

                            <h6 className="fw-bold mt-3">Non-owner personnel details</h6>
                            <dl className="row gy-2 mb-0 mt-2">
                                <dt className="col-sm-4 text-muted">Name</dt>
                                <dd className="col-sm-8">{profileInfo?.contactPerson?.name || '—'}</dd>

                                <dt className="col-sm-4 text-muted">Designation</dt>
                                <dd className="col-sm-8">{profileInfo?.contactPerson?.designation || '—'}</dd>
                            </dl>
                        </div>
                    </div> */}

            {/* Services */}
            {/* <div className="col-12 mb-4">
                        <div className="card shadow-sm rounded-4 p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <h5 className="mb-0">Services</h5>
                                <div>
                                    <button className="btn btn-sm btn-outline-secondary" aria-label="edit">
                                        <i className="bi bi-pencil" />
                                    </button>
                                </div>
                            </div>

                            <dl className="row gy-2 mb-0 mt-2">
                                <dt className="col-sm-4 text-muted">Warehousing services</dt>
                                <dd className="col-sm-8">
                                    {profileInfo?.warehousingServices?.length ? (
                                        <ul className="mb-0">
                                            {profileInfo.warehousingServices.map((s, i) => (
                                                <li key={i}>{s}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <span className="text-muted">—</span>
                                    )}
                                </dd>

                                <dt className="col-sm-4 text-muted">Logistics category</dt>
                                <dd className="col-sm-8">{profileInfo?.logisticsCategory || '—'}</dd>

                                <dt className="col-sm-4 text-muted">Fleet type</dt>
                                <dd className="col-sm-8">{profileInfo?.fleetType || '—'}</dd>

                                <dt className="col-sm-4 text-muted">Related services</dt>
                                <dd className="col-sm-8">
                                    {profileInfo?.relatedServices?.length ? (
                                        <ul className="mb-0">
                                            {profileInfo.relatedServices.map((r, idx) => (
                                                <li key={idx}>{r}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <span className="text-muted">—</span>
                                    )}
                                </dd>
                            </dl>
                        </div>
                    </div> */}

            {/* Documentation */}
            {/* <div className="col-12 mb-4">
                        <div className="card shadow-sm rounded-4 p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <h5 className="mb-0">Documentation</h5>
                                <div>
                                    <button className="btn btn-sm btn-outline-secondary" aria-label="edit">
                                        <i className="bi bi-pencil" />
                                    </button>
                                </div>
                            </div>

                            <div className="d-flex align-items-center gap-3 mt-2">
                                <div className="d-flex align-items-center">
                                    <span className="me-2 bg-light rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: 36, height: 36 }}>
                                        <i className="bi bi-file-earmark-text" />
                                    </span>
                                    <div>
                                        <div className="fw-bold">{profileInfo?.documents?.[0]?.name || 'Article of business.pdf'}</div>
                                        <div>
                                            <a href={profileInfo?.documents?.[0]?.url || '#'} className="small">Download</a>
                                        </div>
                                    </div>
                                </div>

                                <div className="ms-auto">
                                    {profileInfo?.documents?.[0]?.verified ? (
                                        <img src="/images/verif-done.svg" alt="verified" style={{ height: 20 }} />
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div> */}

            {/* Shipping */}
            {/* <div className="col-12 mb-4">
                        <div className="card shadow-sm rounded-4 p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <h5 className="mb-0">Shipping</h5>
                                <div>
                                    <button className="btn btn-sm btn-outline-secondary" aria-label="edit">
                                        <i className="bi bi-pencil" />
                                    </button>
                                </div>
                            </div>

                            <dl className="row gy-2 mb-0 mt-2">
                                <dt className="col-sm-4 text-muted">Shipping address</dt>
                                <dd className="col-sm-8">{profileInfo?.shippingAddress || '—'}</dd>

                                <dt className="col-sm-4 text-muted">Logistics category</dt>
                                <dd className="col-sm-8">{profileInfo?.logisticsCategory || '—'}</dd>

                                <dt className="col-sm-4 text-muted">Fleet type</dt>
                                <dd className="col-sm-8">{profileInfo?.fleetType || '—'}</dd>
                            </dl>
                        </div>
                    </div> */}

            {/* Map / Image */}
            {/* <div className="col-12 mb-4">
                        <div className="card shadow-sm rounded-4 p-0 overflow-hidden">
                            <img
                                // src={p?.mapImageUrl || UPLOADED_IMAGE}
                                alt="map"
                                className="img-fluid w-100"
                                style={{ objectFit: 'cover', height: 220 }}
                            />
                            <div className="p-3 small text-muted">
                                <strong>Latitude:</strong> {profileInfo?.latitude || '—'} &nbsp; <strong>Longitude:</strong> {profileInfo?.longitude || '—'}
                            </div>
                        </div>
                    </div> */}

        </Fragment>
    )
}

BusinessDetails.propTypes = {
    profileInfo: PropTypes.object,
}